import $http from '@/libs/axios'

class HelpAPI {
  public static async add(data: any, type: string) {
    return (await $http.post(`admin/help/${type}/add`, data)).data
  }

  public static async edit(data: any, type: string) {
    return (await $http.post(`admin/help/${type}/update`, data)).data
  }

  public static async delete(id: any, type: string) {
    return (await $http.delete(`admin/help/${type}/delete/${id}`)).data
  }

  public static async show(id: any, type: string) {
    return (await $http.get(`admin/help/${type}/${id}`)).data
  }

  public static async list() {
    return (await $http.get('help/sections')).data
  }
}

export default HelpAPI
